<template>
    <el-dialog title="服务工单" :visible="visibleOrder" width="50%" @close="closeDialog" :close-on-click-modal="false"
        append-to-body>
        <div class="container">
            <div class="fixed-cards">
                <!-- 商户报单详情的表单 -->
                <el-card v-if="declarationInfo" shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>商户报单信息:</span>
                    </div>
                    <div class="card-content">
                        <el-row>
                            <el-col :span="8"><strong>客户姓名:</strong> {{ declarationInfo.customName }}</el-col>
                            <el-col :span="8"><strong>客户手机号:</strong> {{ declarationInfo.customMobile }}</el-col>
                            <el-col :span="8"><strong>客户地址:</strong> {{ declarationInfo.customAddress }}</el-col>
                        </el-row>
                        <!-- 故障现象 -->
                        <el-row>
                            <el-col :span="24">
                                <strong>故障现象:</strong> {{ declarationInfo.faultPhenomenon || '暂无' }}
                            </el-col>
                        </el-row>
                        <!-- 故障照片 -->
                        <el-row v-if="declarationInfo.faultPhotos" class="fault-media-row">
                            <el-col :span="24">
                                <strong>故障照片:</strong>
                                <div class="fault-media-grid">
                                    <viewer :images="formmaterImage(declarationInfo.faultPhotos)">
                                        <img v-for="src in formmaterImage(declarationInfo.faultPhotos)" :src="src"
                                            :key="src" class="fault-media-item fault-photo" />
                                    </viewer>
                                    <span v-if="!formmaterImage(declarationInfo.faultPhotos).length">暂无图片</span>
                                </div>
                            </el-col>
                        </el-row>
                        <!-- 故障视频 -->
                        <el-row v-if="declarationInfo.videoUrl" class="fault-media-row">
                            <el-col :span="24">
                                <strong>故障视频:</strong>
                                <div class="fault-media-grid">
                                    <video v-for="src in formmaterImage(declarationInfo.videoUrl)" :src="src" :key="src"
                                        class="fault-media-item fault-video" controls preload="metadata" />
                                    <span v-if="!formmaterImage(declarationInfo.videoUrl).length">暂无视频</span>
                                </div>
                            </el-col>
                        </el-row>
                        <!-- 是否过保 -->
                        <!-- <el-row v-if="declarationInfo.overinsuredFlag">
                            <el-col :span="24">
                                <strong>是否过保:</strong>
                                {{ declarationInfo.overinsuredFlag === 'YES' ? '是' : declarationInfo.overinsuredFlag === 'NO' ? '否' : declarationInfo.overinsuredFlag }}
                            </el-col>
                        </el-row> -->
                    </div>
                </el-card>
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>服务工单详情:</span>
                    </div>
                    <div class="card-content">
                        <el-row v-if="dynamicColumns.length > 0">
                            <el-col v-for="column in dynamicColumns" :key="column.id"
                                style="display: flex;align-items: center;text-align: center;"
                                :span="getSpan(dynamicColumns.length)">
                                <strong>{{ column.fieldName }}:</strong>
                                <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{
                                    column.fieldValue }}</span>
                                <!-- 评分星级 -->
                                <span v-else-if="column.inputType === 'star'"
                                    style="display: flex;align-items: center;text-align: center;">
                                    <el-rate v-model="column.fieldValue" disabled></el-rate>
                                    <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
                                        column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
                                            column.fieldValue
                                                == '5' ? '非常好' : '' }}</span>
                                </span>
                                <span v-else><time>{{ column.fieldValue }}</time></span>
                            </el-col>
                        </el-row>
                        <el-row v-if="dynamicColumns.length === 0">
                            <el-col :span="24">
                                <p>暂无数据</p>
                            </el-col>
                        </el-row>
                        <!-- 工单工费（labor_cost）：列表接口返回，仅在查看工单时展示 -->
                        <el-row v-if="declarationInfo && declarationInfo.laborCost != null" class="labor-cost-row">
                            <el-col :span="24">
                                <strong>工单工费:</strong>
                                <span class="labor-cost-amount">￥{{ formatMoney(declarationInfo.laborCost) }}</span>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <!-- 实际用料清单：提交工单时落库的最后一次清单 -->
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>实际用料清单:</span>
                    </div>
                    <div class="card-content" v-loading="materialLoading">
                        <template v-if="materials.length > 0">
                            <el-table :data="materials" border size="small" style="width: 100%;">
                                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                                <el-table-column label="商品名称" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.goodsName">{{ scope.row.goodsName }}</span>
                                        <el-tag v-else type="info" size="mini">商品已下架</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="单位" width="80" align="center">
                                    <template slot-scope="scope">{{ scope.row.unit || '-' }}</template>
                                </el-table-column>
                                <el-table-column label="单价（元）" width="110" align="center">
                                    <template slot-scope="scope">{{ formatMoney(scope.row.price) }}</template>
                                </el-table-column>
                                <el-table-column label="数量" width="90" align="center">
                                    <template slot-scope="scope">{{ scope.row.num == null ? '-' : scope.row.num }}</template>
                                </el-table-column>
                                <el-table-column label="小计（元）" width="110" align="center">
                                    <template slot-scope="scope">{{ formatMoney(scope.row.amount) }}</template>
                                </el-table-column>
                            </el-table>
                            <div class="material-total">
                                合计：<span class="material-total-amount">￥{{ totalAmount }}</span>
                            </div>
                        </template>
                        <el-row v-else>
                            <el-col :span="24">
                                <p>暂无用料记录</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="imageFields.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>工单清单图片信息:</span>
                    </div>
                    <div class="form-row" v-for="column in imageFields" :key="column.id">
                        <p class="gap-line-border" v-if="column.inputType === 'img'">
                            <span class="nameStyle">{{ column.fieldName }}:</span>
                            <span class="gap-line"></span>
                            <span v-if="column.fieldValue">
                                <viewer :images="formmaterImage(column.fieldValue)">
                                    <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src"
                                        class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- 反查主报单的防水服务工单（纯手动售后无 parentId 时不展示） -->
            <el-button v-if="!readonly && declarationInfo && declarationInfo.parentId" type="primary" plain icon="el-icon-tickets"
                :loading="parentOrderLoading" @click="handleViewParentOrder">主订单工单</el-button>
            <!-- 待终审状态下在工单内完成审核 -->
            <template v-if="!readonly && declarationInfo && declarationInfo.status === 'TO_BE_THE_FINAL'">
                <el-button type="success" icon="el-icon-check" :loading="auditLoading"
                    @click="handleStatusAudit">通过</el-button>
                <el-button type="danger" icon="el-icon-close" :loading="auditLoading"
                    @click="handleStatusRefuse">拒绝</el-button>
            </template>
            <!-- 待评价、已完成状态下允许反审核（终审撤回，接口侧兜底校验） -->
            <el-button
                v-if="!readonly && declarationInfo && ['TO_BE_EVALUATED', 'COMPLETE'].includes(declarationInfo.status)"
                type="warning" plain icon="el-icon-refresh-left" :loading="auditLoading"
                @click="handleReverseAudit">反审核</el-button>
            <el-button @click="closeDialog">关闭</el-button>
        </span>

        <!-- 通过审核：可选填写工费（labor_cost） -->
        <el-dialog title="通过审核" :visible.sync="auditVisible" width="420px" append-to-body
            :close-on-click-modal="false">
            <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="110px">
                <el-form-item label="是否填写工费">
                    <el-radio-group v-model="auditForm.needLaborCost" @change="handleNeedLaborCostChange">
                        <el-radio label="YES">是</el-radio>
                        <el-radio label="NO">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="auditForm.needLaborCost === 'YES'" label="工费（元）" prop="laborCost">
                    <el-input v-model="auditForm.laborCost" placeholder="请输入工费金额" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="auditVisible = false">取消</el-button>
                <el-button type="primary" size="small" :loading="auditLoading" @click="submitStatusAudit">确定通过</el-button>
            </span>
        </el-dialog>

        <!-- 主订单工单：复用防水阶段工单弹窗（与商户页“工单”按钮打开的是同一个组件），反查主订单属跨模块互查，固定只读隐藏操作按钮 -->
        <view-water-proof-stage :visibleStage.sync="parentStageVisible" :orderId="parentDeclarationId"
            :status="parentRow.orderStatus || ''" :id="parentDeclarationId" :infoDetail="parentRow"
            :readonly="true" @openViewOrder="handleOpenParentViewOrder" />
        <!-- 阶段弹窗内触发查看旧版服务工单（orderId 为主报单 deliveryOrderId，id 为主报单 id），固定只读隐藏操作按钮 -->
        <merchant-view-order :visibleOrder.sync="parentOrderVisible" :orderId="parentOrderId"
            :id="parentDeclarationId" :readonly="true" />
    </el-dialog>
</template>

<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { getFulfillmentMaterials, reverseAuditAfterSale } from "@/api/salesCloud/afterSale";
// 主报单工单 id（deliveryOrderId）仅 ListV2 聚合返回，按主报单 id 单条查询
import { findWaterProof } from "@/api/work/waterProof/merchants";
// 通过/拒绝复用售后单管理（/work/afterSales）的更新接口
import { updateAfterSalesOrder } from "@/api/work/afterSales/afterSales";
// 主订单工单复用防水商户报单的阶段工单弹窗（与商户页“工单”按钮一致），旧版服务工单弹窗兜底
import ViewWaterProofStage from "@/views/work/waterProof/merchants/components/viewWaterProofStage.vue";
import MerchantViewOrder from "@/views/work/waterProof/merchants/components/viewOrder.vue";
export default {
    name: "AfterSaleViewOrder",
    components: { ViewWaterProofStage, MerchantViewOrder },
    props: {
        visibleOrder: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        declarationInfo: {
            type: Object,
            default: () => ({}),
        },
        // 跨模块互查场景下只读，隐藏所有操作按钮（审核/反审核/反查主订单），仅保留关闭
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
            materials: [], // 实际用料清单
            materialLoading: false,
            auditLoading: false, // 审核提交中
            // 主订单工单弹窗（反查主报单的防水阶段工单）
            parentOrderLoading: false,
            parentStageVisible: false,
            parentOrderVisible: false,
            parentOrderId: '',
            parentDeclarationId: '',
            parentRow: {},
            // 通过审核弹窗（可选填写工费）
            auditVisible: false,
            auditForm: {
                needLaborCost: 'NO',
                laborCost: ''
            },
            auditRules: {
                laborCost: [
                    { required: true, message: '请输入工费金额', trigger: 'blur' },
                    { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额（最多两位小数）', trigger: 'blur' }
                ]
            },
        };
    },
    computed: {
        // 合计金额：amount 缺失（商品已下架）的行不计入
        totalAmount() {
            const total = this.materials.reduce((sum, item) => {
                const amount = Number(item.amount);
                return isNaN(amount) ? sum : sum + amount;
            }, 0);
            return total.toFixed(2);
        },
    },
    watch: {
        /**
         *
         * @param newVal
         * @description 监听 visibleOrder 的变化
         * @returns void
         */
        visibleOrder(newVal) {
            if (newVal && this.orderId) {
                // 获取动态控件类型
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;
                    this.fetchGoodsData(this.orderId);
                }).catch(err => {
                    this.$message.error('获取动态控件类型失败', err);
                });
                this.fetchMaterials(this.orderId);
            }
        }
    },
    methods: {
        /**
         *
         * @param orderId 工单ID
         * @description 获取工单数据
         * @returns void
         */
        fetchGoodsData(orderId) {
            const params = {
                id: orderId,
                code: 'AFTER_SALES_ORDER'
            };
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data);
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType),
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType),
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    this.dynamicColumns = dynamicColumns;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message.error('获取数据失败', err);
            });
        },
        /**
         *
         * @param afterSaleId 售后单ID
         * @description 获取实际用料清单（未提交过实际用料时为空数组，属正常态）
         * @returns void
         */
        fetchMaterials(afterSaleId) {
            this.materialLoading = true;
            this.materials = [];
            getFulfillmentMaterials(afterSaleId).then(res => {
                if (res && res.code == '200') {
                    let data = res.data;
                    if (typeof data === 'string') {
                        try {
                            data = JSON.parse(data);
                        } catch (e) {
                            data = [];
                        }
                    }
                    this.materials = Array.isArray(data) ? data : [];
                } else {
                    this.$message({
                        showClose: true,
                        message: (res && res.message) || '获取实际用料清单失败',
                        type: 'error'
                    });
                }
                this.materialLoading = false;
            }).catch(() => {
                this.materialLoading = false;
            });
        },
        /**
         *
         * @param val 金额
         * @description 金额展示，缺失（商品已下架/单价异常）时降级为 -
         * @returns string
         */
        formatMoney(val) {
            if (val == null || isNaN(Number(val))) return '-';
            return Number(val).toFixed(2);
        },
        /**
         *
         * @param length
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         *
         * @param row
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         *
         * @param inputType
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : '';
        },
        /**
         *
         * @description 反查主报单的工单：ListV2 按 parentId 查整行后，打开与商户页“工单”按钮一致的阶段工单弹窗
         * @returns void
         */
        handleViewParentOrder() {
            const parentId = this.declarationInfo && this.declarationInfo.parentId;
            if (!parentId) return;
            this.parentOrderLoading = true;
            findWaterProof({ id: parentId, page: 1, size: 1 }).then(res => {
                this.parentOrderLoading = false;
                if (res && res.code == '200') {
                    let data = res.data;
                    if (typeof data === 'string') {
                        try {
                            data = JSON.parse(data);
                        } catch (e) {
                            data = {};
                        }
                    }
                    const parent = (data && data.rows && data.rows[0]) || null;
                    // 严格校验返回行就是当前主报单，防止 id 过滤未生效时错拿他单数据
                    if (!parent || String(parent.id) !== String(parentId)) {
                        this.$message.warning('未查询到主订单信息');
                        return;
                    }
                    this.parentRow = parent;
                    this.parentDeclarationId = parent.id;
                    this.parentOrderId = parent.deliveryOrderId || '';
                    this.parentStageVisible = true;
                } else {
                    this.$message({
                        showClose: true,
                        message: (res && res.message) || '查询主订单信息失败',
                        type: 'error'
                    });
                }
            }).catch(() => {
                this.parentOrderLoading = false;
            });
        },
        /**
         *
         * @description 阶段工单弹窗内点“查看工单”时打开旧版服务工单（依赖主报单 deliveryOrderId）
         * @returns void
         */
        handleOpenParentViewOrder() {
            if (!this.parentOrderId) {
                this.$message.warning('主订单暂无服务工单');
                return;
            }
            this.parentOrderVisible = true;
        },
        /**
         *
         * @description 通过（待终审 -> 待评价），弹窗确认是否填写工费
         * @returns void
         */
        handleStatusAudit() {
            if (!this.declarationInfo || this.declarationInfo.status !== 'TO_BE_THE_FINAL') return;
            this.auditForm = { needLaborCost: 'NO', laborCost: '' };
            this.auditVisible = true;
            this.$nextTick(() => {
                this.$refs.auditForm && this.$refs.auditForm.clearValidate();
            });
        },
        /**
         *
         * @description 切换是否填写工费，选否时清空已输入金额及校验
         * @returns void
         */
        handleNeedLaborCostChange(val) {
            if (val === 'NO') {
                this.auditForm.laborCost = '';
                this.$nextTick(() => {
                    this.$refs.auditForm && this.$refs.auditForm.clearValidate();
                });
            }
        },
        /**
         *
         * @description 确定通过：选是时校验并携带 laborCost（对应 labor_cost 工费），选否时不传
         * @returns void
         */
        submitStatusAudit() {
            const doSubmit = () => {
                const payload = { ...this.declarationInfo, status: 'TO_BE_EVALUATED' };
                if (this.auditForm.needLaborCost === 'YES') {
                    payload.laborCost = Number(this.auditForm.laborCost);
                }
                this.submitAudit(payload);
            };
            if (this.auditForm.needLaborCost === 'YES') {
                this.$refs.auditForm.validate(valid => {
                    if (!valid) return;
                    doSubmit();
                });
            } else {
                doSubmit();
            }
        },
        /**
         *
         * @description 拒绝（待终审 -> 服务中，需填写拒绝原因）
         * @returns void
         */
        handleStatusRefuse() {
            if (!this.declarationInfo || this.declarationInfo.status !== 'TO_BE_THE_FINAL') return;
            this.$prompt('请输入拒绝原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: '请输入正确长度的拒绝原因1-255'
            }).then(({ value }) => {
                this.submitAudit({ ...this.declarationInfo, status: 'IN_SERVICE', reason: value });
            }).catch(() => {
                this.$message({
                    showClose: true,
                    message: '操作取消',
                    type: 'info'
                });
            });
        },
        /**
         *
         * @param payload 审核提交数据
         * @description 提交审核结果，成功后关闭弹窗并通知父组件刷新列表
         * @returns void
         */
        submitAudit(payload) {
            this.auditLoading = true;
            updateAfterSalesOrder(payload).then(res => {
                if (res && res.code == '200') {
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    this.auditVisible = false;
                    this.$emit('refresh');
                    this.closeDialog();
                } else {
                    this.$message({
                        showClose: true,
                        message: (res && res.message) || '操作失败',
                        type: 'error'
                    });
                }
                this.auditLoading = false;
            }).catch(err => {
                this.$message.error((err && err.message) || '操作失败');
                this.auditLoading = false;
            });
        },
        /**
         *
         * @description 反审核（待评价/已完成 -> 待终审）：确认后调用后端反审核接口，
         *              冲正材料账户与工费打款，状态回退到待终审。成功后通知父组件刷新列表。
         * @returns void
         */
        handleReverseAudit() {
            if (!this.declarationInfo) return;
            const status = this.declarationInfo.status;
            if (status !== 'TO_BE_EVALUATED' && status !== 'COMPLETE') {
                this.$message({
                    showClose: true,
                    message: '当前状态不支持反审核',
                    type: 'warning'
                });
                return;
            }
            const afterSaleId = this.declarationInfo.id;
            if (!afterSaleId) {
                this.$message({
                    showClose: true,
                    message: '售后单 id 缺失，无法反审核',
                    type: 'error'
                });
                return;
            }
            this.$confirm('反审核将冲正材料账户与工费打款，并回退到待终审状态，是否继续？', '反审核提示', {
                confirmButtonText: '确定反审核',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.auditLoading = true;
                reverseAuditAfterSale(afterSaleId).then(res => {
                    if (res && res.code == '200') {
                        this.$message({
                            showClose: true,
                            message: '反审核成功',
                            type: 'success'
                        });
                        this.$emit('refresh');
                        this.closeDialog();
                    } else {
                        this.$message({
                            showClose: true,
                            message: (res && res.message) || '反审核失败',
                            type: 'error'
                        });
                    }
                    this.auditLoading = false;
                }).catch(err => {
                    this.$message.error((err && err.message) || '反审核失败');
                    this.auditLoading = false;
                });
            }).catch(() => {
                this.$message({
                    showClose: true,
                    message: '已取消反审核',
                    type: 'info'
                });
            });
        },
        /**
         *
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            this.$emit("update:visibleOrder", false);
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.nameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
}

.card strong {
    color: #333;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}

.material-total {
    margin-top: 12px;
    text-align: right;
    font-size: 14px;
    color: #303133;
}

.material-total-amount {
    font-weight: bold;
    font-size: 16px;
    color: #f56c6c;
}

.labor-cost-row {
    margin-top: 10px;
}

.labor-cost-amount {
    font-weight: bold;
    color: #f56c6c;
}

.fault-media-row {
    margin-top: 10px;
    margin-bottom: 10px;
}

.fault-media-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 8px;
}

.fault-media-item {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
    background: #fafbfc;
    object-fit: cover;
}

.fault-photo {
    width: 100px;
    height: 100px;
}

.fault-video {
    width: 140px;
    height: 100px;
}

.fault-media-item:hover {
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}

@media (max-width: 768px) {
    .fault-media-grid {
        gap: 8px;
    }

    .fault-photo,
    .fault-video {
        width: 80px;
        height: 60px;
    }
}
</style>
